import React, { useState, useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import "./MainLayout.css";

const MainLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [activeRoute, setActiveRoute] = useState("");

  // Navigation items with modern icons and descriptions
  const navigationItems = [
    {
      path: "/elevation/dem",
      title: "Elevation Model",
      icon: "🏔️",
      description: "Digital Elevation Mapping"
    },
    {
      path: "/crop-monitoring",
      title: "Crop Health",
      icon: "🌱",
      description: "Real-time Monitoring"
    },
    {
      path: "/analytics/indices",
      title: "Analytics Hub",
      icon: "📊",
      description: "Indices Dashboard"
    },
    {
      path: "/agriculture/crop-maps",
      title: "Crop Maps",
      icon: "🗺️",
      description: "Agricultural Mapping"
    },
    {
      path: "/climate/cyclones",
      title: "Cyclone Track",
      icon: "🌪️",
      description: "Weather Monitoring"
    }
  ];

  // Update active route when location changes
  useEffect(() => {
    setActiveRoute(location.pathname);
  }, [location]);

  // Handle responsive sidebar behavior
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setIsSidebarOpen(false);
      } else {
        setIsSidebarOpen(true);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Check initial size

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleNavigation = (path) => {
    navigate(path);
    // Auto-close sidebar on mobile after navigation
    if (window.innerWidth <= 768) {
      setIsSidebarOpen(false);
    }
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="main-layout">
      {/* Modern Sidebar */}
      <div className={`sidebar ${isSidebarOpen ? "" : "collapsed"}`}>
        <button
          className="toggle-button"
          onClick={toggleSidebar}
          title={isSidebarOpen ? "Collapse Sidebar" : "Expand Sidebar"}
          aria-label={isSidebarOpen ? "Collapse Sidebar" : "Expand Sidebar"}
        >
          {isSidebarOpen ? "◀" : "▶"}
        </button>

        <div className="sidebar-content">
          <h2>🌾 Agri-Insights </h2>

          <nav role="navigation" aria-label="Main navigation">
            {navigationItems.map((item) => (
              <button
                key={item.path}
                onClick={() => handleNavigation(item.path)}
                className={`nav-button ${activeRoute === item.path ? "active" : ""}`}
                title={item.description}
                aria-current={activeRoute === item.path ? "page" : undefined}
              >
                <span className="nav-icon" role="img" aria-hidden="true">
                  {item.icon}
                </span>
                <div className="nav-text">
                  <span className="nav-title">{item.title}</span>
                  <span className="nav-subtitle">{item.description}</span>
                </div>
              </button>
            ))}
          </nav>
        </div>
      </div>

      {/* Modern Main Content */}
      <main className="main-content" role="main">
        <Outlet />
      </main>

      {/* Mobile overlay when sidebar is open */}
      {isSidebarOpen && window.innerWidth <= 768 && (
        <div
          className="sidebar-overlay"
          onClick={() => setIsSidebarOpen(false)}
          aria-hidden="true"
        />
      )}
    </div>
  );
};

export default MainLayout;